/* eslint-disable no-console */
// let dateMeta = [
//   "same day (eee): ",
//   "same month (dee): ",
//   "full month (fee): ",
//   "same year (dde): ",
//   "full months (fde): ",
//   "full year (ffe): ",
//   "days (ddd): ",
//   "months (fdd): ",
//   "years (ffd): "
// ]
// let dateStart = [
//   new Date(2000, 4, 4), // same day (eee)
//   new Date(1989, 2, 1), // same month (dee)
//   new Date(1989, 2, 1), // full month (fee)
//   new Date(1989, 2, 1), // same year (dde)
//   new Date(2017, 1, 1), // full months (fde)
//   new Date(2005, 0, 1), // full year (ffe)
//   new Date(1996, 10, 8), // days (ddd)
//   new Date(1996, 10, 1), // months (fdd)
//   new Date(1996, 0, 1), // years (ffd)
// ]
// let dateEnd = [
//   new Date(2000, 4, 4), // same day (eee)
//   new Date(1989, 2, 3), // same month (dee)
//   new Date(1989, 3, 0), // full month (fee)
//   new Date(1989, 7, 9), // same year (dde)
//   new Date(2017, 10, 0), // full months (fde)
//   new Date(2006, 0, 0), // full year (ffe)
//   new Date(2019, 9, 3), // days (ddd)
//   new Date(2019, 9, 0), // months (fdd)
//   new Date(2019, 0, 0), // years (ffd)
// ]

export default {
  dateOptions(type) {
    let options = {};
    if (type.includes("era")) {
      options.era = "short";
      options.year = "numeric";
      options.month = "long";
      options.day = "numeric";
    }
    if (type.includes("year")) {
      options.year = "numeric";
    }
    if (type.includes("month")) {
      options.month = "long";
    }
    if (type.includes("day")) {
      options.day = "numeric";
    }
    if (type.includes("time")) {
      options.year = "numeric";
      options.month = "2-digit";
      options.day = "2-digit";
      options.hour = "2-digit";
      options.minute = "2-digit";
    }
    return options;
  },

  sameYear(start, end) {
    return start.getFullYear() == end.getFullYear();
  },
  sameMonth(start, end) {
    return this.sameYear(start, end) && start.getMonth() == end.getMonth();
  },
  sameDay(start, end) {
    return this.sameMonth(start, end) && start.getDate() == end.getDate();
  },

  wholeMonth(start, end) {  // === full day (1 a ~31)
    let month = end.getMonth(), startDay = start.getDate(), endDay = end.getDate();
    let lastDay = (new Date(0, month + 1, 0)).getDate();
    return startDay == 1 && endDay == lastDay;
  },
  wholeYear(start, end) {   // === full month (0 a 11)
    return start.getMonth() == 0 && end.getMonth() == 11 && this.wholeMonth(start, end);
  },

  toDate(date, options = "", locale = "pt-BR") {
    if (date instanceof Date && !isNaN(date))
      return new Intl.DateTimeFormat(locale, this.dateOptions(options)).format(date);
    return null;
  },

  timePeriod(start, end) {
    if (!start || !end) {
      return null;
    }
    start = new Date(start);
    end = new Date(end);
    let optionsStart = "";
    let optionsEnd = "";

    // ERA
    if (start.getFullYear() <= 0) {
      optionsStart = optionsStart.concat("era");
      optionsEnd = optionsEnd.concat("era");
    }

    // YEAR
    optionsEnd = optionsEnd.concat("year");
    if (!this.sameYear(start, end)) {
      optionsStart = optionsStart.concat("year");
    }

    // MONTH
    if (!this.wholeYear(start, end)) {
      optionsEnd = optionsEnd.concat("month");
      if (!this.sameMonth(start, end)) {
        optionsStart = optionsStart.concat("month");
      }
    }

    // DAY
    if (!this.wholeMonth(start, end)) {
      optionsEnd = optionsEnd.concat("day");
      if (!this.sameDay(start, end)) {
        optionsStart = optionsStart.concat("day");
      }
    }

    if (optionsStart == "") return { full: this.toDate(end, optionsEnd) };
    return {
      start: this.toDate(start, optionsStart),
      end: this.toDate(end, optionsEnd)
    };
  },

  minDate(date, baseDate) {
    if (Number(date.year) <= Number(baseDate.year)) {
      date.year = Number(baseDate.year);
      if (baseDate.month != '' && Number(date.month) <= Number(baseDate.month)) {
        date.month = Number(baseDate.month);
        if (baseDate.day != '' && Number(date.day) < Number(baseDate.day)) {
          date.day = Number(baseDate.day);
        }
      }
    }
  },
  maxDate(date, baseDate) {
    if (Number(date.year) >= baseDate.getFullYear()) {
      if (Number(date.month) >= baseDate.getMonth() + 1) {
        if (Number(date.day) >= baseDate.getDate()) {
          date.day = baseDate.getDate();
        }
        date.month = baseDate.getMonth() + 1;
      }
      date.year = baseDate.getFullYear();
    }
  },
  valiDate(date) {
    if (date.month < 0 && date.month != '') date.month = 1;
    if (date.day < 0 && date.day != '') date.day = 1;
    if (date.month > 12) date.month = 12;
    if (date.day > 28) {
      let d = new Date(date.year, date.month, 0);
      if (date.day > d.getDate()) date.day = d.getDate();
    }
  },

  trimDateStart(date) {
    let { year, month, day } = date;
    if (year == '')
      return null;
    let d = new Date(year, Math.max(month - 1, 0), Math.max(day, 1));
    if (!isNaN(d) && year >= 0 && year < 100)
      d.setFullYear(year);
    return !isNaN(d) ? d : null;
  },

  trimDateEnd(dateEnd, dateStart) {
    let { year, month, day } = dateEnd;
    let empty = ['', 0];
    if (empty.indexOf(year) >= 0) {
      if (empty.indexOf(dateStart.year) >= 0)
        return null;
      else year = dateStart.year;
    }
    if (empty.indexOf(month) >= 0) {
      if (empty.indexOf(dateStart.month) >= 0)
        month = 12;
      else month = dateStart.month;
    }
    if (empty.indexOf(day) >= 0) {
      if (empty.indexOf(dateStart.day) >= 0) {
        month++;
        day = 0;
      }
      else day = dateStart.day;
    }

    let d = new Date(year, Math.min(month - 1, 12), Math.min(day, 31));
    if (!isNaN(d) && year >= 0 && year < 100)
      d.setFullYear(year);
    d.setHours(23, 59, 59, 999);
    return !isNaN(d) ? d : null;
  },
}
